<template>
  <div class="profile">
    <div class="box is-shadowless">
      <div class="columns">
        <div class="column is-6">

          <div class="card">

            <header class="card-header has-background-dark">
              <p class="card-header-title has-text-light">
                {{ user.firstName | uppercase }}
              </p>
            </header>

            <div class="card-content scrollable px-0" style="padding: 0;">

              <b-tabs v-model="userDetailsActiveTab">

                <b-tab-item label="PROFILE">

                  <form @submit.prevent="onSubmit">

                    <b-field label="Name">
                      <b-input v-model="form.firstName"></b-input>
                    </b-field>

                    <!-- <b-field label="Last Name">
                      <b-input v-model="form.lastName"></b-input>
                    </b-field> -->

                    <b-field label="Email">
                      <b-input v-model="form.email" type="email"></b-input>
                    </b-field>

                    <b-field label="Mobile">
                      <b-input v-model="form.mobile"></b-input>
                    </b-field>

                    <b-field>

                      <permission-checkboxes
                        :checked.sync="form.permissions"
                        :params="{ type: 'user:self_manageable' }"
                      ></permission-checkboxes>

                    </b-field>
                    <b-field label="Start Route">
                      <b-select
                        v-model="form.startRoute"
                        expanded
                      >
                        <option :value="startRoute.value" v-for="startRoute in startRoutes" :key="startRoute.value">
                          {{ startRoute.label }}
                        </option>
                      </b-select>
                    </b-field>

                    <b-field label="Order Split Preference">
                      <b-input v-model="form.orderSplitPreference"></b-input>
                    </b-field>

                    <b-field :label="$t('dictionary')">
                      <b-select
                        v-model="form.dictionary"
                        expanded
                      >
                        <option value="generic">Generic</option>
                        <option value="custom">Custom</option>
                      </b-select>
                    </b-field>

                    <b-field label="Vacation Delegate">
                      <base-select
                        label
                        :service="$options.userService"
                        fetch-func="all"
                        :fetch-params="{
                          firmId: user.firm.id,
                          archived: false}"
                        value-key="id"
                        :value.sync="form.delegate_user_id"
                      >
                        <template #customLabel="{ option }">
                          {{ option.firstName }}
                        </template>
                      </base-select>
                    </b-field>

                     <b-field label="Vacation Start">
                        <b-datepicker
                            v-model="form.away_start"
                            placeholder="Click to select..."
                            icon="calendar">
                        </b-datepicker>
                    </b-field>

                    <b-field label="Vacation End">
                        <b-datepicker
                            v-model="form.away_end"
                            placeholder="Click to select..."
                            icon="calendar">
                        </b-datepicker>
                    </b-field>

                    <b-field label="Default x">
                      <b-input v-model="form.lat"></b-input>
                    </b-field>

                    <b-field label="Default y">
                      <b-input v-model="form.lng"></b-input>
                    </b-field>
                    <b-field label="Map">
                      <LeafletOfflineMap :config="{height: 400}"
                      :markers="markers"
                      @click-map="clickMap"
                      ref="userMap"
                      />
                    </b-field>
                  </form>

                </b-tab-item>

                <b-tab-item label="TELEPORT ACTIVITY">

                  <b-table
                    :data="teleportActvityInbound.length === 0 ? [] : teleportActvityInbound"
                    :bordered="false"
                    :striped="false"
                    :narrowed="true"
                    :hoverable="false"
                    :loading="false"
                    :focusable="false"
                    :mobile-cards="false"
                    class="teleport-activity">

                    <template slot-scope="props">

                      <b-table-column field="created_at" label="Date">
                          {{ props.row.createdAt | toLocalDateAndTime }}
                      </b-table-column>

                      <b-table-column field="content" label="Activity">
                          {{ props.row.content }}
                      </b-table-column>

                    </template>

                    <template #empty>
                        <div class="has-text-centered">No activity found.</div>
                    </template>

                  </b-table>

                </b-tab-item>

                <b-tab-item label="API KEYS" v-if="canViewApiKeys">

                  <key-table />

                </b-tab-item>

              </b-tabs>

            </div>
            <footer v-if="userDetailsActiveTab == 0" class="card-footer">
              <b-button
                class="is-fullwidth"
                type="is-link"
                :loading="loading"
                @click.prevent="onSubmit"
              >
                UPDATE
              </b-button>
            </footer>
          </div>
        </div>
        <div class="column is-6" v-if="experimentalInterface">

          <div class="card user-form">

            <header class="card-header has-background-dark">
              <p class="card-header-title has-text-light">
                ORDER FILTER EDIT
              </p>
            </header>

            <div class="card-content scrollable">
              <order-filter-edit ref="orderFilterEdit" />
            </div>

            <footer class="card-footer">
              <b-button
                class="is-fullwidth"
                type="is-link"
                :loading="updatingFilter"
                @click.prevent="updateFilter"
              >
                UPDATE
              </b-button>
            </footer>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

    import OrderFilterEdit from "@/components/OrderFilter/OrderFilterEdit";
    import PermissionCheckboxes from "@/components/Permission/PermissionCheckboxes";
    import Roles from "@/helpers/roles";
    import { startRoutes } from "@/helpers/start-routes";
    import { UserService } from "@/services/user.service";
    import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
    import LeafletOfflineMap from "@/components/LeafletOfflineMap";
    import BaseSelect from "@/components/partials/BaseSelect";
    import KeyTable from "@/components/Key/KeyTable";

export default {

  userService: UserService,
  components: {
    OrderFilterEdit,
    PermissionCheckboxes,
    LeafletOfflineMap,
    BaseSelect,
    KeyTable,
  },
  data: () => ({
    userDetailsActiveTab: 0,
    teleport_activity: [],
    form: {
      dictionary: "",
      firstName: "",
      // lastName: "",
      email: "",
      mobile: "",
      permissions: [],
      lat: null,
      lng: null,
      away_start: null,
      away_end: null,
      delegate_user_id: null,
      startRoute: "",
      orderSplitPreference: "",
    },
    startRoutes: [],
    loading: false,
    updatingFilter: false
  }),
  computed: {

    user() {
      return this.$store.state.Auth.user;
    },

    markers() {
      if (this.form.lat && this.form.lng) {
        return [{
          latLng: [this.form.lat, this.form.lng],
        }];
      }
      return [];
    },

    experimentalInterface() {
      return this.$store.getters["Auth/hasPermission"](
        "experimental interface"
      );
    },
    canViewApiKeys() {
      return this.$store.getters["Auth/hasPermission"](
        "can view api keys"
      );
    },

    dictionary() {
      return this.$store.getters["Auth/dictionary"];
    },
    teleportActvityInbound() {
      const user = this.$store.state.Auth.user;
      const items = this.teleport_activity.filter(log => {
        const log_subtype_upper = log.subtype ? log.subtype.toUpperCase() : null;
        return (user && user.id == log.loggable_id && log_subtype_upper == 'TELEPORT_IN');
      });
      return items;
    }
  },

  mounted() {

    this.getRouteData()
      .then(all => {
        const { teleport_activity } = all;
        this.teleport_activity = teleport_activity;
      })
      .catch(err => {
        window.console && console.log(err);
      });

    this.startRoutes = startRoutes;

    // let orderSplitPreference = localStorage.getItem(
    //   "__orders_page_split_sizes"
    // );
    // orderSplitPreference = orderSplitPreference
    //   ? JSON.parse(orderSplitPreference).join(",")
    //   : this.$store.getters["Auth/orderSplitPreference"];
    this.form = {
      firstName: this.user.fullName,
      // lastName: "",
      email: this.user.email || "",
      mobile: this.user.mobile || "",
      lat: this.user.default_x,
      lng: this.user.default_y,
      away_start: this.user.awayStart ? new Date(this.user.awayStart) : null,
      away_end: this.user.awayEnd ? new Date(this.user.awayEnd) : null,
      delegate_user_id: this.user.delegateUserId,
      permissions: this.user.permissions
        ? this.user.permissions.map(permission => permission.id)
        : [],
      startRoute: this.$store.getters["Auth/startRoute"],
      // orderSplitPreference,
      orderSplitPreference: this.$store.getters["Auth/orderSplitPreference"],
      dictionary: this.dictionary
    };

  },
  methods: {
    async getRouteData() {
      try {
        let all = {
          teleport_activity: [],
        };
        const data = await Promise.all([
          this.getTeleportActivity(),
        ]);
        all['teleport_activity'] = data[0];
        return all;
      }
      catch (err) {
        throw err;
      }
    },
    async getTeleportActivity() {
      try {
        const user = this.$store.state.Auth.user;
        const response = await UserService.getTeleportActivity(user.id);
        const teleport_activity = JsonDenormalizer.denormalize(response);
        return teleport_activity;
      }
      catch (err) {
        throw err;
      }
    },
    transformedData() {
      return {
        first_name: this.form.firstName,
        // last_name: this.form.lastName,
        email_address: this.form.email,
        mobile_number: this.form.mobile,
        permission_ids: this.form.permissions,
        firm_id: this.user.firm.id,
        active: this.user.active ? 1 : 0,
        default_x: this.form.lat,
        default_y: this.form.lng,
        away_start: this.form.away_start,
        away_end: this.form.away_end,
        delegate_user_id: this.form.delegate_user_id,
        start_route: this.form.startRoute,
        order_split_preference: this.form.orderSplitPreference,
        dictionary: this.form.dictionary
      };
    },
    async onSubmit() {
      this.loading = true;

      try {
        const user = await this.$options.userService
          .update(this.user.id, {
            ...this.transformedData(),
            includes: "firm,roles,permissions,attributes"
          })
          .then(response => JsonDenormalizer.denormalize(response));

        this.$store.dispatch("Auth/setUser", user);

        // if (this.form.orderSplitPreference) {
        //   localStorage.setItem(
        //     "__orders_page_split_sizes",
        //     JSON.stringify(
        //       this.form.orderSplitPreference.split(",").map(v => parseFloat(v))
        //     )
        //   );
        // }

        this.$buefy.toast.open({
          message: "Profile has been updated.",
          type: "is-info",
          position: "is-top-right"
        });
      } catch (err) {}

      this.loading = false;
    },
    async updateFilter() {
      this.updatingFilter = true;

      try {
        await this.$refs.orderFilterEdit.update();
      } catch (err) {}

      this.updatingFilter = false;
    },
    clickMap(event){
      this.form.lat = event.latlng.lat;
      this.form.lng = event.latlng.lng;
      this.$nextTick(()=>{
        this.$refs.userMap.loadMarkers();
      })
      this.$refs.userMap.clearLayer("markers");

    }
  }
};

</script>

<style lang="scss" scoped>
    .scrollable {
        height: calc(88vh - 44px - 56px);
    }
    .teleport-activity td:first-child {
      white-space: nowrap;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/Profile/index.vue